var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.item},[_vm._t("default"),(!_vm.readonly)?_c('div',{class:_vm.$style.button},[_c('AddRemoveButton',{attrs:{"isLast":_vm.isLast,"i":_vm.recordIndex,"length":_vm.sizeArr,"firstNonRemovable":_vm.firstNonRemovable},on:{"remove":_vm.deleteRow,"add":_vm.addRow}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }